//Document ready
$(document).ready(function() {
	headerNavButtonClick();

	//Initializations
	$(".header-main").headroom({
		offset: 75
	});
});

//Resize
$(window).resize(function() {
	if (window.matchMedia("(min-width: 48em)").matches) {
		$(".nav-main").removeClass("js-transition");
		headerMaskHide();
		headerNavHide();
	}
});

//Header nav
function headerNavButtonClick() {
	$(".header-nav-button").click(function() {
		if (!$(".nav-main").hasClass("js-transition")) {
			$(".nav-main").addClass("js-transition");
		}

		if (!$(".nav-main").hasClass("js-open")) {
			headerNavShow();
			headerMaskShow();
		} else {
			headerNavHide();
			headerMaskHide();
		}
	});
}

function headerNavShow() {
	$(".nav-main").addClass("js-open");
	$(".header-nav-button").addClass("js-open");
	$("body,html").addClass("no-scroll");
}

function headerNavHide() {
	$(".nav-main").removeClass("js-open");
	$(".header-nav-button").removeClass("js-open");
	$("body,html").removeClass("no-scroll");
}

//Header Mask
function headerMaskClick() {
	$(".header-mask").click(function() {
		headerNavHide();
		headerMaskHide();
	});
}

function headerMaskShow() {
	$(".header-mask").fadeIn(200);
}

function headerMaskHide() {
	$(".header-mask").fadeOut(200);
}
